import React, {Component} from "react";
import DatePicker from 'react-datepicker';
import moment from "moment";
import 'react-datepicker/dist/react-datepicker.css';
import {connect} from "react-redux";
import {getResultLine} from "../../../redux/actions/result";
import Loading from "../../../components/Loading";
import SportIcon from "../../../components/SportIcon";
import League from "./modules/League";
import Event from "./modules/Event";
import {Link} from "react-router-dom";
import * as lodash from "lodash";

class ResultLineContainer extends Component {
	state = {
		selectedDate  : moment(),
		selectedSport : -1
	};

	componentWillMount() {
		moment.updateLocale('en', {
			months : ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь",
			          "Ноябрь", "Декабрь"],
			weekdaysMin: 'Вс_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
			week   : {
				dow : 1
			}
		});

		this.props.onGetResultLine(this.state.selectedDate.format('YYYY-MM-DD'));
	}

	onSportChange(e) {
		this.setState({
			selectedSport : parseInt(e.target.value)
		});
	}

	handleChange(date) {
		this.props.onGetResultLine(date.format('YYYY-MM-DD'));

		this.setState({
			selectedDate : date
		});
	}

	render() {
		const {sports, events, leagues, results} = this.props.resultLine;
		const sortedSports = lodash.sortBy(sports, s => s.name);

		const data = sortedSports.map((sport, index) => {
				if ( this.state.selectedSport !== -1 && +sport.id !== this.state.selectedSport ) {
					return <div></div>;
				}

				return (
					<div key={`line-result-data-${index}`} className="live-event-data">
						<div className="events__header">
							<div className="events__header__sportname">
						<span className="sport-icon small green events__header__sporticon">
							<SportIcon sportId={sport.id}/>
						</span>
								<span>&nbsp;<Link to={`/live-sport/${sport.id}`}>{sport.name}</Link></span>
							</div>
						</div>
						<div className="events">
							<div className="events__table table-div">
								{leagues.filter((league) => {return league.sport_id === sport.id}).map((league) =>
									<League key={league.id} league={league}>
										{events.filter((event) => {return event.league_id === league.id}).map((event) =>
											<Event key={event.id} event={event} results={results.filter((result) => {return result.event === event.id})}/>)}
									</League>
								)}
							</div>
						</div>
					</div>
				)
			}
		);

		return (
			<div className="body__container__side-right result-live">
				<div className="live-event-header result-live__header">
					<div className="no-dot">Результаты</div>
				</div>

				<div className="result">
					<div className="result__filter">
						<select className="result__filter-sport" onChange={this.onSportChange.bind(this)} value={this.state.selectedSport}>
							<option key="all-sports" value={-1}>Все</option>
							{sports.map((sport) => <option key={sport.id} value={sport.id}>{sport.name}</option>)}
						</select>

						<label className="result__filter-date">
							<span>Дата</span>
							<DatePicker selected={this.state.selectedDate}
							            onChange={this.handleChange.bind(this)}
							            dateFormat={'DD.MM.YYYY'}
							            todayButton={true}/>
						</label>
					</div>

					{this.props.resultLine.fetching ? <Loading/> : data}
				</div>
			</div>
		);
	}
}

export default connect(
	state => ({
		resultLine : state.result.line
	}),
	dispatch => ({
		onGetResultLine : (date) => {
			dispatch(getResultLine(date));
		}
	})
)(ResultLineContainer);


// WEBPACK FOOTER //
// ./src/app/pages/Result/Line/ResultLineContainer.js